import React from 'react';
import CommentSkeletonCard from './CommentSkeletonCard';

const SKELETON_COUNT = 4;

function CommentsSkeleton() {
  return (
    <div className="space-y-2 p-3" aria-busy="true" aria-label="Loading comments">
      {Array.from({ length: SKELETON_COUNT }, (_, i) => (
        <CommentSkeletonCard key={i} />
      ))}
    </div>
  );
}

export default CommentsSkeleton;
